import { invertedLabels } from '../../constants/analytics/categoryActionLabel/subscribe';

export default function getSubscribeEventLabel(label, location) {
  const querySource = location?.query?.source;
  const isDuplicate = invertedLabels[querySource];
  return querySource && !isDuplicate ? `${label}.${querySource}` : label;
}
